import React, { useState, useEffect } from "react";
import { List, Paper, makeStyles } from "@material-ui/core";

import TreeContainer from "./TreeContainer";
import SearchBar from "../CommonComponents/SearchBar";
import { transformDmaData } from "../TreeUtils";
import { useDebounce } from "../../../hooks";

const useStyles = makeStyles(() => ({
  paper: {
    width: 300,
    height: 350,
    overflow: "auto",
    padding: "0 10px",
  },
}));

const CustomList = ({
  items = [],
  listHeader,
  selected,
  setSelected,
  searchVal,
  setSearchVal,
}) => {
  const classes = useStyles();
  const debouncedSearchValue = useDebounce(searchVal);
  const [list, setList] = useState(() => {
    return transformDmaData(items);
  });

  useEffect(() => {
    setList(transformDmaData(items));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [items]);

  useEffect(() => {
    setList(
      transformDmaData(
        items.filter((item) =>
          item.nameDMA
            .toLowerCase()
            .includes(debouncedSearchValue.toLowerCase())
        )
      )
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedSearchValue]);

  return (
    <Paper className={classes.paper}>
      <List
        dense
        component="div"
        role="list"
        subheader={
          <SearchBar
            listHeader={listHeader}
            searchVal={searchVal}
            setSearchVal={setSearchVal}
          />
        }
      >
        <TreeContainer
          selected={selected}
          setSelected={setSelected}
          data={list}
        />
      </List>
    </Paper>
  );
};

export default CustomList;
